import React from "react";
import { Button } from "@mui/material";
import { CloudUploadOutlined } from "@mui/icons-material";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";
const Previewer = ({ fileInputRef, children }) => {
  return (
    <React.Fragment>
      <Button
        startIcon={
          <CloudUploadOutlined
            sx={{ transform: "scale(2)", fill: themeColors.ColorPrimary }}
          />
        }
        fullWidth
        variant="outlined"
        sx={{
          paddingY: "3em",
          borderStyle: "dashed",
          borderWidth: "3px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1em",
          border: `1px dashed ${themeColors.ColorPrimary}`,
        }}
        onClick={() => fileInputRef.current.click()}
      >
        {children}
      </Button>
    </React.Fragment>
  );
};

export default Previewer;
